var React = require('react');

function SasIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.158.001c-.28-.006-.567.026-.862.1-1.364.34-2.89 2.096-1.224 4.12l.995 1.205.28.343c.19.224.497.22.724.033s.293-.496.105-.724l-.114-.138h.005l-.162-.2-.77-.933c-.724-.88-.4-1.964.58-2.58.865-.543 2.453-.35 3 .543C6.37.76 5.366.028 4.158.001zm.2 2.124a.57.57 0 0 0-.376.138c-.228.188-.292.496-.105.724a7.91 7.91 0 0 0 .062.076l1.005 1.214c.724.88.4 1.96-.58 2.576-.865.543-2.453.35-3-.543.424 1.252 1.846 2.07 3.42 1.676 1.365-.34 2.89-2.09 1.224-4.115l-1.167-1.4-.133-.167a.47.47 0 0 0-.348-.171z","fill":"#007cc2"}));
}

SasIcon.defaultProps = {"width":"64","height":"64","viewBox":"0 0 8.078 8.087"};

module.exports = SasIcon;

SasIcon.default = SasIcon;
